module.exports = __webpack_public_path__ + "a76ffd79976171bc130429687bbea0bc.png";


//////////////////
// WEBPACK FOOTER
// ./app/containers/Premium/components/PromotionBlock/images/promotion_image3.png
// module id = 1485
// module chunks = 3